import Dashboard from './Dashboard';
import Tunnel from './Tunnel';

export default {
  ...Dashboard,
  ...Tunnel,
};
